// Сторона карты в единицах сцены. Координаты ответа — доли миникарты ×10 000,
// в сцене — доли ×1000: точка (u, v) → (u / 10, v / 10).
export const WORLD_SIZE = 1000;

// Доли миникарты ×10 000 → единицы сцены.
export const UV_TO_WORLD = WORLD_SIZE / 10_000;
